import { render } from "./CardBoxComponentLoad.vue?vue&type=template&id=fd2eb04a"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__